import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Typography,
  TextField,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import LayoutUserHeader from '../components/LayoutUserHeader';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

const PaymentDetails = () => {
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filteredOrders, setFilteredOrders] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const gstNumber = localStorage.getItem('gstNumber');

const res = await axios.get(`${BASE_URL}/Order/GetAllOrders`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
      const data = res.data.data || [];
      console.log(data);
      const filtered = data.filter(o => o.GstNumber === gstNumber);
      console.log('Filtered Orders:', filtered);
      setOrders(filtered);
      setFilteredOrders(filtered);
    } catch (err) {
      console.error('Error fetching orders', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    const filtered = orders.filter(order =>
      order.GstNumber?.toLowerCase().includes(value) ||
      order.FinancialYear?.toLowerCase().includes(value)
    );
    setFilteredOrders(filtered);
  };

  const handleClick = async (e) => {
    e.preventDefault();

     const scriptLoaded = await loadRazorpayScript();
  if (!scriptLoaded) {
    alert('Razorpay SDK failed to load. Are you online?');
    return;
  }
  try {
      let finalAmount = 0;
      let discountPercent = 0;
  
      const discountRes = await axios.get(`${BASE_URL}/Discount/GetActiveDiscount`);
      const discount = discountRes.data.data;
  
      if (discount) {
        discountPercent = discount.discountPercent;
        const discountValue = (discountPercent / 100) * discount.amount;
        finalAmount = discount.amount - discountValue;
      }
  
      const finalAmountWithGST = finalAmount + (finalAmount * 18 / 100);
  
      const today = new Date();
      const month = today.getMonth() + 1;
      const year = today.getFullYear();
      const financialYear = month >= 4 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
  
      const options = {
        key: 'rzp_live_rT0exN68NQKT7n',
        amount: Math.round(finalAmountWithGST * 100),
        currency: 'INR',
        name: 'Eas Up Tax',
        description: 'Transaction',
        // prefill: {
        //   name: `${formData.firstName} ${formData.lastName}`,
        //   email: formData.emailId,
        //   contact: formData.mobileNumber
        // },
        // notes: {
        //   address: formData.address || 'N/A'
        // },
        theme: {
          color: '#F37254'
        },
  
        handler: async function (response) {
          alert(`Payment successful! Payment ID: ${response.razorpay_payment_id}`);
  
          const orderPayload = {
            GstNumber: localStorage.getItem('gstNumber'),
            FinancialYear: '2026-2027',
            OrderAmount: finalAmount,
            Discount: discountPercent,
            FinalAmount: finalAmount
          };
  
          try {
            await axios.post(`${BASE_URL}/Order/AddOrder`, orderPayload);
  
            navigate('/PaymentDetails');
  
          } catch (err) {
            console.error('Error after payment:', err);
            toast.error('Payment done, but something went wrong while saving registration or order.');
          }
        }
      };
  
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
  
    } catch (error) {
      console.error('Error in handleSubmit:', error);
      toast.error('Something went wrong during initialization.');
    }

  };

  const columns = [
    {
      field: 'GstNumber',
      headerName: 'GST Number',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'FinancialYear',
      headerName: 'Financial Year',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'OrderAmount',
      headerName: 'Amount (₹)',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'Discount',
      headerName: 'Discount (%)',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'FinalAmount',
      headerName: 'Final Amount (₹)',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
  ];

  return (
    <>
      <LayoutUserHeader />
      <Box p={2}>
        <br/>
        <br/>
        <br/>
        <Typography variant="h5" gutterBottom>
          Payment Details
        </Typography>
         <Box display="flex" justifyContent="flex-end" mb={2}>
            <Button variant="contained" color="primary" onClick={handleClick}>
                Add Payment For 2026-2027 
            </Button>
        </Box>

        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <TextField
            label="Search Year"
            variant="outlined"
            value={search}
            onChange={handleSearch}
            fullWidth
          />
        </Box>

        <DataGrid
          autoHeight
          rows={filteredOrders.map((order, index) => ({ ...order, id: index }))}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[5, 10, 20]}
          loading={loading}
          disableSelectionOnClick
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#f0f0f0',
              fontWeight: 'bold',
              fontSize: '16px',
            },
            '& .MuiDataGrid-cell': {
              fontSize: '14px',
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#fafafa',
            },
          }}
        />
      </Box>
      <br/>
       <br/>
        <br/>
         <br/>
          <br/>
           <br/>
            <br/>
             <br/>
              <br/>
               <br/>
                <br/>
                 <br/>
                  <br/>
                   <br/>
                    <br/>
                     <br/>
                      <br/>
                       <br/>
                         <br/>
                        <br/>
    </>
  );
};

export default PaymentDetails;
